<div mat-dialog-content class="dialog_body">
  <mat-icon color="primary">error_outlined</mat-icon>
  <h1>{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.DIALOG.TITLE' | translate }}</h1>
  <P> {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.DIALOG.DESCRIPTION' | translate }} </P>
</div>
<div mat-dialog-actions>
  <div class="dialog_footer">
    <button mat-button (click)="onClickCloseOrCancel()" cdkFocusInitial>
      {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.DIALOG.BUTTON_CANCEL' | translate }}
    </button>
    <button mat-flat-button color="warn" [mat-dialog-close]="true">
      {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.DIALOG.BUTTON_CONFIRM' | translate }}
    </button>
  </div>
</div>
